import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab } from '@mui/material';
import ErrorCode from 'v2/core/errors/codes';
import { RegisterState } from 'v2/views/layouts/authenticationModule/authTypes';
import { AUTH_ERROR_CODE_MESSAGE } from 'v2/views/layouts/authenticationModule/constants';
import { RegisterView } from './RegisterView';
import { SignInView } from './SignInView';
import { AuthView } from './types';

interface SignInOrRegisterContainerProps {
  selectedView: AuthView;
  setUserPayload: (userPayload: RegisterState) => void;
  setAuthErrorMessage: (errorMessage: string) => void;
  setIsOTPViewVisible: (isVisible: boolean) => void;
  setSelectedView: (view: AuthView) => void;
  email: string;
  onChangeEmail: (email: string) => void;
}

export const SignInOrRegisterContainer = ({
  selectedView,
  setUserPayload,
  setAuthErrorMessage,
  setIsOTPViewVisible,
  setSelectedView,
  email,
  onChangeEmail,
}: SignInOrRegisterContainerProps) => {
  const handleTabChange = (
    _: React.SyntheticEvent<Element, Event>,
    tabValue: AuthView,
  ) => {
    setSelectedView(tabValue);
    setAuthErrorMessage('');
  };

  const onSetUserPayload = (payload: RegisterState, otpView: boolean) => {
    setUserPayload(payload);
    setIsOTPViewVisible(otpView);
  };

  const onSsoError = () => {
    setAuthErrorMessage(AUTH_ERROR_CODE_MESSAGE[ErrorCode.InvalidSsoIdpToken]);
  };

  return (
    <TabContext value={selectedView}>
      <TabList onChange={handleTabChange}>
        <Tab label="Sign in" value={AuthView.SignIn} />
        <Tab label="Register" value={AuthView.Register} />
      </TabList>
      <TabPanel value={AuthView.SignIn} sx={{ px: 0, pb: 1 }}>
        <SignInView
          setAuthErrorMessage={setAuthErrorMessage}
          onSetUserPayload={onSetUserPayload}
          email={email}
          onChangeEmail={onChangeEmail}
        />
      </TabPanel>
      <TabPanel value={AuthView.Register} sx={{ px: 0, pb: 1 }}>
        <RegisterView
          onSetUserPayload={onSetUserPayload}
          setAuthErrorMessage={setAuthErrorMessage}
          onSsoError={onSsoError}
          email={email}
          onChangeEmail={onChangeEmail}
        />
      </TabPanel>
    </TabContext>
  );
};
